import { Data2, dateToString, newId } from '../../../features/data-types'
import { O } from '../../../features/ui'
import { TableName } from '../../../tables'
import { useSystemStateHooks } from '../../system'
import { Delivery, DeliveryItem, DeliveryMethod, DeliveryStatus, NotDeliveredItem } from '../state/types'

export const useDeliveryBuilders = () => {
    const { companyId } = useSystemStateHooks()

    const buildDeliveryItem = (data: Data2) => {
        const { itemId, quantity, deliveredQuantity, notDeliveredQuantity, defectiveQuantity } = data
        const deliveryItem: DeliveryItem = {
            itemId: itemId! as string,
            quantity: quantity! as number,
            deliveredQuantity: deliveredQuantity! as number,
            notDeliveredQuantity: notDeliveredQuantity! as number,
            defectiveQuantity: defectiveQuantity as O<number>
        }
        
        return deliveryItem
    }

    const buildDelivery = (data: Data2) => {
        const {
            id = newId(),
            code,
            codeStr,
            table,
            operationId,
            orderId,
            method,
            items,
            creationDate,
            date,
            customerId,
            branchId,
            addressId,
            deliveryStatus,
            deliveryNoteUrl,
            supplierDeliveryNoteNumber,
            fromNotDeliveredItems,
            cancelled
        } = data
        const delivery: Delivery = {
            companyId: companyId!,
            id: id! as string,
            code: code! as number,
            codeStr: codeStr as O<string>,
            table: table! as TableName,
            operationId: operationId! as string,
            orderId: orderId as O<string>,
            method: method! as DeliveryMethod,
            items: (items || []) as DeliveryItem[],
            creationDate: dateToString(creationDate || new Date())!,
            date: dateToString(date || new Date())!,
            customerId: customerId as O<string>,
            branchId: branchId! as string,
            addressId: addressId! as string,
            deliveryStatus: (deliveryStatus || DeliveryStatus.PENDING) as DeliveryStatus,
            deliveryNoteUrl: deliveryNoteUrl as O<string>,
            supplierDeliveryNoteNumber: supplierDeliveryNoteNumber as O<string>,
            fromNotDeliveredItems: (fromNotDeliveredItems || []) as NotDeliveredItem[],
            cancelled: cancelled as O<boolean>
        }

        return delivery
    }

    return {
        buildDeliveryItem,
        buildDelivery
    }
}
